export const isInViewport = (ref, offset = 0) => {
  if (!ref) return false;
  const top = ref.getBoundingClientRect().top;
  const bottom = ref.getBoundingClientRect().bottom;
  return (
    top + offset >= 0 &&
    top - offset <= window.innerHeight &&
    bottom + offset >= 0 &&
    bottom - offset <= window.innerHeight
  );
};
